<template>
  <div class="rootDiv">
    <div class="title-div">
      <div :style="{'float': 'left','width': '30%','visibility':model.backTitle!==null?'visible':'hidden'}">
        <Button style="background-color: #67b676;color: black;margin: 0;padding: 0" @click="backPage">
          <img src="../../../assets/images/32/back.png" height="32" width="32" slot="icon" alt="">
          <span style="font-size: 0.8rem">{{ model.backTitle }}</span>
        </Button>
      </div>
      <div style="float: left;width: 40%;text-align: center;margin-top: 0.2rem">
        <span>{{ model.title }}简介</span>
      </div>
      <div style="float: left;width: 30%"></div>
      <div style="clear: both"></div>
    </div>
    <div v-html="details.jJ"></div>
    <div class="title-div">
      <span>{{ details.mC }}地址</span>
    </div>
    <div style="padding-top: 10px;padding-bottom: 10px;">
      <span>{{ details.wZ }}</span>
    </div>
    <div class="title-div">
      <span>{{ details.mC }}图片</span>
    </div>
    <div v-for="item in details.tP" :key="item.yURL" style="float: left;margin-left: -0.5rem">
      <img :src="item.yURL" alt="" :width="width">
    </div>
  </div>
</template>

<script>

import {Button, Indicator} from "mint-ui";

export default {
  name: "VillageDetails",
  components: {
    Button
  },
  data() {
    return {
      model: {title: '全国', backTitle: null, id: 0},
      width: document.documentElement.clientWidth,
      details: {
        mC: null,
        jJ: null,
        tp: [],
      },
      token: localStorage.getItem('token'),
      getVillageDetailsUrl: '/api/yigecun/getVillageDetails',
    }
  },
  mounted() {
    if (this.$route.query.id !== undefined) {
      let record = localStorage.getItem("Record_List")
      let record_json = JSON.parse(record)
      const record_array = [];
      for (let i in record_json) {
        record_array.push(record_json [i])
      }
      this.model = record_array[record_array.length - 1]
      this.getDetails(this.$route.query.id)
    } else
      this.$router.go(-1)
  },
  methods: {
    backPage() {
      let record = localStorage.getItem("Record_List")
      let record_json = JSON.parse(record)
      const record_array = [];
      for (let i = 0; i < record_json.length - 1; i++) {
        record_array.push(record_json [i])
      }
      localStorage.setItem('Record_List', JSON.stringify(record_array))
      this.$router.replace({name: 'm_village', params: {isBack: '1'}})
    },
    getDetails(id) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getVillageDetailsUrl,
        params: {id: id},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          that.details = response.data['responseData']
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.title-div {
  background-color: #67b676;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  text-align: center;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
  text-align: left;
}

</style>
